import { render } from "./LifeTimeComponent.vue?vue&type=template&id=6155ecf4&scoped=true"
import script from "./LifeTimeComponent.vue?vue&type=script&lang=js"
export * from "./LifeTimeComponent.vue?vue&type=script&lang=js"

import "./LifeTimeComponent.vue?vue&type=style&index=0&id=6155ecf4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6155ecf4"]])

export default __exports__